module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/5@2x_00a92e1427f789d94a2925901806d3ed.png";